import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Button, TextField, Grid, Select, MenuItem, Box, FormControl, InputLabel, InputAdornment, IconButton, Tooltip, Typography } from "@mui/material";
import {
  People,
  Inventory,
  Business,
  Person,
  BusinessCenter,
  ShoppingCart,
  TrendingUp,
  Description,
  CalendarToday,
  KeyboardArrowDown,
  InfoOutlined as InfoOutlinedIcon,
} from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import { LoadingButton } from "@mui/lab";
import { apiData } from "../services/api_service";
import {
  config,
  dashboardAPI,
  dashboardAPI1,
  listStoreAPI,
  storeFilterAPI,
  statusMasterAPI,
} from "../config";
import StoreIcon from "@mui/icons-material/Store";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { _getDropdownListData } from "../service";
import { formatNumber, formatAED } from "../utils/format";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

import Chart from "react-apexcharts";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaymentsIcon from "@mui/icons-material/Payments";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

function Dashboard() {
  const [storeId, setStoreId] = useState(0);
  const [selectedStore, setSelectedStore] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    totalProducts: 0,
    totalPos: 0,
    totalActivePos: 0,
    totalInActivePos: 0,
    totalSalesOrders: 0,
    totalActiveSalesOrders: 0, 
    totalInactiveSalesOrders : 0,
    totalCreditsGiven: 0,
    totalSales: 0,
    pendingPayments: 0,
    salesCategories: {
      cashSales: 0,
      bankTransferSales: 0,
      cardSales: 0,
      chequeSales: 0,
      onlineSales: 0,
    },
    financialOverview: {
      invoicesOwed: 0,
      billsToPay: 0,
      recentPayments: 0,
      netProfitYTD: 0,
    },
  });
  const [storeData, setStoreData] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [clientSearch, setClientSearch] = useState("");
  const [invoiceSearch, setInvoiceSearch] = useState("");
  const [amountSearch, setAmountSearch] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");

  const navigate = useNavigate();

  const StatCard = ({
    title,
    value,
    icon: Icon,
    variant,
    trend,
    onClick,
    navigateTo,
    additionalData,
    type,
  }) => {
    if (type === "employee") {
      return (
        <div className="employee-card employee-variant">
          <div className="employee-card-header">
            <div className="employee-icon">
              <Icon />
            </div>
            <div className="employee-total" onClick={() => onClick("total")}>
              <span>Total Employees</span>
              <h2>{value}</h2>
            </div>
          </div>

          <div className="employee-breakdown">
            <div
              className="employee-break-item"
              onClick={() => onClick("active")}
            >
              <span>Active Employees</span>
              <h3>{additionalData?.active}</h3>
            </div>

            <div
              className="employee-break-item"
              onClick={() => onClick("inactive")}
            >
              <span>Inactive Employees</span>
              <h3>{additionalData?.inactive}</h3>
            </div>
          </div>

          <div className="stat-decoration"></div>
        </div>
      );
    } else if (type === "salesOrder") {
      return (
        <div className="employee-card sales-order-variant">
          <div className="employee-card-header">
            <div className="employee-icon">
              <Icon />
            </div>
            <div className="employee-total" onClick={() => onClick("total")}>
              <span>Invoice</span>
              <h2>{value}</h2>
            </div>
          </div>

          <div className="employee-breakdown">
            <div
              className="employee-break-item"
              onClick={() => onClick("active")}
            >
              <span>Created</span>
              <h3>{additionalData?.active}</h3>
            </div>

            <div
              className="employee-break-item"
              onClick={() => onClick("inactive")}
            >
              <span>Cancelled</span>
              <h3>{additionalData?.inactive}</h3>
            </div>
          </div>

          <div className="stat-decoration"></div>
        </div>
      );
    } else if (type === "purchaseOrder") {
      return (
        <div className="employee-card purchase-order-variant">
          <div className="employee-card-header">
            <div className="employee-icon">
              <Icon />
            </div>
            <div className="employee-total" onClick={() => onClick("total")}>
              <span>Purchase Order</span>
              <h2>{value}</h2>
            </div>
          </div>

          <div className="employee-breakdown">
            <div
              className="employee-break-item"
              onClick={() => onClick("active")}
            >
              <span>Created</span>
              <h3>{additionalData?.active}</h3>
            </div>

            <div
              className="employee-break-item"
              onClick={() => onClick("inactive")}
            >
              <span>Cancelled</span>
              <h3>{additionalData?.inactive}</h3>
            </div>
          </div>

          <div className="stat-decoration"></div>
        </div>
      );
    }

    return (
      <div
        className={`stat-card ${variant}`}
        onClick={() => {
          if (!navigateTo) return;

          if (typeof navigateTo === "string") {
            navigate(navigateTo);
          } else if (typeof navigateTo === "object") {
            navigate(navigateTo.path, { state: navigateTo.state });
          }
        }}
        style={{ cursor: navigateTo ? "pointer" : "default" }}
      >
        <div className="stat-content">
          <div className="stat-header">
            <div className="stat-icon">
              <Icon fontSize="medium" />
            </div>
            {trend && (
              <span className="stat-trend">
                <TrendingUp fontSize="small" />
                {trend}
              </span>
            )}
          </div>
          <h3 className="stat-title">{title}</h3>
          <div className="stat-value">{value}</div>

          {additionalData && (
            <div className="stat-additional">
              {additionalData.map((item, index) => (
                <div key={index} className="stat-additional-item">
                  <span className="stat-additional-label">{item.label}:</span>
                  <span className="stat-additional-value">{item.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="stat-decoration"></div>
      </div>
    );
  };

  const fetchStore = async () => {
    try {
      setLoading(true);
      const response = await apiData("get", listStoreAPI);
      if (response?.success) {
        setStoreData(response.data);
      } else {
        console.error("API returned unsuccessful:", response);
      }
    } catch (error) {
      console.error("Dashboard Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStore();
  }, []);

  const fetchStoreFilteredData = async (storeId) => {
    try {
      if (storeId === 0) {
        fetchData(fromDate, toDate);
        return;
      }

      const response = await apiData("get", storeFilterAPI, {
        store_id: storeId,
      });

      if (response?.success && response.data) {
        const stats = response.data;

        setDashboardData((prev) => ({
          ...prev,
          totalPos: stats.totalPos || 0,
          totalActivePos: stats.totalActivePos || 0,
          totalInActivePos: stats.totalInActivePos || 0,
          totalSalesOrders: stats.totalSalesOrders || 0,
          totalActiveSalesOrders: stats.totalActiveSalesOrders || 0,
          totalInActiveSalesOrders: stats.totalInactiveSalesOrders || 0,
          totalProducts: stats.totalProducts || 0,
          totalCreditsGiven: stats.totalCreditsGiven || 0,
        }));
      }

    } catch (error) {
      console.error("Store filter fetch error:", error);
    }
  };

  const fetchData = async (
    from = "",
    to = "",
    store = 0,
    client = "",
    invoice = "",
    amount = "",
    global = ""
  ) => {
    try {
      setLoading(true);

      const formattedFrom = from ? dayjs(from).format("YYYY-MM-DD") : "";
      const formattedTo = to ? dayjs(to).format("YYYY-MM-DD") : "";

      const response = await apiData("get", dashboardAPI1, {
        from_date: formattedFrom,
        to_date: formattedTo,
        store_id: store,
        client: client,
        invoice_no: invoice,
        amount: amount,
        global_search: global,
      });

      if (response?.success) {
        setDashboardData(response.data);
      } else {
        console.error("API returned unsuccessful:", response);
      }
    } catch (error) {
      console.error("Dashboard Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("", "", 0, "", "", "", "");
  }, []);

  const handleApplyFilter = () => {
    fetchData(
      fromDate,
      toDate,
      selectedStore,
      clientSearch,
      invoiceSearch,
      amountSearch,
      globalSearch
    );
  };

  const handleClearFilter = () => {
    setFromDate(null);
    setToDate(null);
    setClientSearch("");
    setInvoiceSearch("");
    setAmountSearch("");
    setGlobalSearch("");
    setStoreId(0);
    setSelectedStore(0);
    fetchData("", "", 0, "", "", "", "");
  };

  return (
    <Layout>
      <div className="dashboard-container" style={{ paddingTop: "25px" }}>
        {/* Header Section with Field Filters & Global Search */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            p: 2.5,
            mb: 3,
            mt: 3.5,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            border: "1px solid #e2e8f0",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            {/* Global Search */}
            <Grid item xs={12} md={4} lg={3}>
              <TextField
                fullWidth
                size="small"
                label="Global Search"
                placeholder="Search anything..."
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleApplyFilter()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                  endAdornment: globalSearch && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => setGlobalSearch("")}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* From Date */}
            <Grid item xs={12} sm={6} md={2.5} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  label="From Date"
                  inputFormat="YYYY-MM-DD"
                  value={fromDate}
                  onChange={(newValue) => setFromDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {/* To Date */}
            <Grid item xs={12} sm={6} md={2.5} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  label="To Date"
                  inputFormat="YYYY-MM-DD"
                  value={toDate}
                  onChange={(newValue) => setToDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {/* Store Selection */}
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <FormControl fullWidth size="small">
                <InputLabel id="store-select-label">Store</InputLabel>
                <Select
                  labelId="store-select-label"
                  value={storeId}
                  label="Store"
                  onChange={(e) => {
                    setStoreId(e.target.value);
                    setSelectedStore(e.target.value);
                  }}
                >
                  <MenuItem value={0}>ALL STORES</MenuItem>
                  {storeData.map((store) => (
                    <MenuItem value={store.id} key={store.id}>
                      {store.store_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Client / Customer Filter */}
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <TextField
                fullWidth
                size="small"
                label="Client / Customer"
                placeholder="Client name"
                value={clientSearch}
                onChange={(e) => setClientSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleApplyFilter()}
              />
            </Grid>

            {/* Invoice / Order No Filter */}
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <TextField
                fullWidth
                size="small"
                label="Client Invoice No"
                placeholder="Invoice No"
                value={invoiceSearch}
                onChange={(e) => setInvoiceSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleApplyFilter()}
              />
            </Grid>

            {/* Amount Filter */}
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Amount (AED)"
                placeholder="Min Amount"
                value={amountSearch}
                onChange={(e) => setAmountSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleApplyFilter()}
              />
            </Grid>

            {/* Filter Action Buttons */}
            <Grid item xs={12} md={3.5} lg={2.5} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <LoadingButton
                variant="contained"
                color="primary"
                size="small"
                fullWidth
                loading={loading}
                loadingPosition="start"
                onClick={handleApplyFilter}
                startIcon={<FilterAltIcon />}
              >
                Apply
              </LoadingButton>
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                fullWidth
                onClick={handleClearFilter}
                startIcon={<RefreshIcon />}
              >
                Reset
              </Button>
              <Tooltip
                title={
                  <Box sx={{ p: 0.5, fontSize: "0.75rem", lineHeight: 1.4 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#fff", mb: 0.5, fontSize: "0.82rem" }}>
                      Dashboard Filter Information
                    </Typography>
                    <div style={{ marginBottom: "4px" }}>
                      <strong>Applied filters update:</strong>
                    </div>
                    <ul style={{ margin: 0, paddingLeft: 16 }}>
                      <li>Invoice Count (Total, Active, Inactive)</li>
                      <li>Total Sales Revenue (AED)</li>
                      <li>Pending Payments & Pending Credits</li>
                      <li>Payment Categories (Cash, Card, Bank, Cheque, Online)</li>
                    </ul>
                    <div style={{ marginTop: "6px", fontStyle: "italic", opacity: 0.9 }}>
                      *Date range also filters Employee, Product, Customer & Vendor totals.
                    </div>
                  </Box>
                }
                arrow
                placement="top"
              >
                <IconButton size="small" sx={{ color: "#64748b", "&:hover": { color: "#1e293b", backgroundColor: "#f1f5f9" } }}>
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>

        {/* Stats Grid */}
        <div className="stats-grid">
          <StatCard
            type="purchaseOrder"
            title="Sales Order"
            value={formatNumber(dashboardData?.totalPos || 0)}
            icon={ShoppingCart}
            additionalData={{
              active: dashboardData?.totalActivePos || 0,
              inactive: dashboardData?.totalInActivePos || 0,
            }}
            onClick={(clicked) => {
              console.log("Clicked:", clicked);
              if (clicked === "total") {
                navigate("/purchase-order/list", {
                  state: {
                    filters: [],
                    reportTitle: "Purchase Order Report",
                  },
                });
              }
              if (clicked === "active") {
                navigate("/purchase-order/list", {
                  state: {
                    filters: [{ id: "order_status", value: "Completed" }],
                    reportTitle: "Completed Purchase Orders Report",
                  },
                });
              }
              if (clicked === "inactive") {
                console.log("Applying Cancelled filter");
                navigate("/purchase-order/list", {
                  state: {
                    filters: [{ id: "order_status", value: "Cancelled" }],
                    reportTitle: "Cancelled Purchase Orders Report",
                  },
                });
              }
            }}
          />

          <StatCard
            type="salesOrder"
            title="Invoice"
            value={formatNumber(dashboardData?.totalSalesOrders || 0)}
            icon={ShoppingCart}
            additionalData={{
              active: dashboardData?.totalActiveSalesOrders || 0,
              inactive: dashboardData?.totalInActiveSalesOrders || 0,
            }}
            onClick={(clicked) => {
              console.log("Clicked:", clicked);
              if (clicked === "total") {
                navigate("/invoice/list", {
                  state: {
                    filters: [],
                    reportTitle: "Invoice Report",
                  },
                });
              }
              if (clicked === "active") {
                navigate("/invoice/list", {
                  state: {
                    filters: [{ id: "order_status", value: "Completed" }],
                    reportTitle: "Completed Invoices Report",
                  },
                });
              }
              if (clicked === "inactive") {
                console.log("Applying Cancelled filter");
                navigate("/invoice/list", {
                  state: {
                    filters: [{ id: "order_status", value: "Cancelled" }],
                    reportTitle: "Cancelled Invoices Report",
                  },
                });
              }
            }}
          />

          <StatCard
            title="Total Sales"
            value={`${formatAED(dashboardData?.totalSales)}`}
            icon={PointOfSaleIcon}
            variant="tertiary"
            navigateTo={{
              path: "/order/list",
              state: {
                reportTitle: "Total Sales Report",
              },
            }}
          />

          {/* <StatCard
            title="Pending Payments"
            value={`${formatAED(dashboardData?.pendingPayments)}`}
            icon={AccountBalanceWalletIcon}
            variant="quaternary"
            navigateTo={{
              path: "/order/list",
              state: {
                filters: [{ id: "payment_status", value: "Pending" }],
                reportTitle: "Pending Payments Report",
              },
            }}
          /> */}

         

          <StatCard
            title="Total Credit Amounts Pending"
            value={`${formatAED(dashboardData?.totalCreditsGiven)}`}
            icon={CreditScoreIcon}
            variant="primary"
            navigateTo={{
              path: "/order/list",
              state: {
                filters: [
                  { id: "payment_type", value: "credit" },
                  { id: "payment_status", value: "Pending" },
                ],
                reportTitle: "Pending Credit Report",
              },
            }}
          />
        </div>

        {/* Business Overview Chart & Sales Categories Section */}
        <Grid container spacing={3} sx={{ mt: 1, mb: 3 }}>
          {/* Business Overview Financial Chart */}
          <Grid item xs={12} lg={8}>
            <div className="dashboard-header" style={{ height: "100%", margin: 0 }}>
              <h3 style={{ margin: "0 0 16px 0", color: "#1e293b", fontWeight: 700 }}>
                Business Overview Financial Metrics
              </h3>
              <Chart
                options={{
                  chart: { type: "bar", height: 320, toolbar: { show: false } },
                  colors: ["#6366f1", "#ef4444", "#10b981", "#3b82f6"],
                  plotOptions: { bar: { borderRadius: 8, columnWidth: "50%" } },
                  dataLabels: { enabled: false },
                  xaxis: {
                    categories: [
                      "Invoices Owed to You",
                      "Bills to Pay",
                      "Recent Invoice Payments",
                      "Net Profit / Loss (YTD)",
                    ],
                    labels: { style: { colors: "#64748b", fontWeight: 600 } },
                  },
                  yaxis: {
                    labels: {
                      formatter: (val) => `${formatAED(val)}`,
                      style: { colors: "#64748b" },
                    },
                  },
                  tooltip: {
                    y: { formatter: (val) => `${formatAED(val)}` },
                  },
                }}
                series={[
                  {
                    name: "Amount (AED)",
                    data: [
                      dashboardData?.financialOverview?.invoicesOwed || 0,
                      dashboardData?.financialOverview?.billsToPay || 0,
                      dashboardData?.financialOverview?.recentPayments || 0,
                      dashboardData?.financialOverview?.netProfitYTD || 0,
                    ],
                  },
                ]}
                type="bar"
                height={320}
              />
            </div>
          </Grid>

          {/* Sales Categories Column */}
          <Grid item xs={12} lg={4}>
            <div className="dashboard-header" style={{ height: "100%", margin: 0 }}>
              <h3 style={{ margin: "0 0 14px 0", color: "#1e293b", fontWeight: 700, fontSize: "15px" }}>
                Sales Categories
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <PaymentsIcon style={{ color: "#10b981", fontSize: "18px" }} />
                    <span style={{ fontWeight: 600, color: "#334155", fontSize: "13px" }}>Cash Sales</span>
                  </div>
                  <strong style={{ color: "#0f172a", fontSize: "13px" }}>{formatAED(dashboardData?.salesCategories?.cashSales)}</strong>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <AccountBalanceIcon style={{ color: "#3b82f6", fontSize: "18px" }} />
                    <span style={{ fontWeight: 600, color: "#334155", fontSize: "13px" }}>Bank Transfers</span>
                  </div>
                  <strong style={{ color: "#0f172a", fontSize: "13px" }}>{formatAED(dashboardData?.salesCategories?.bankTransferSales)}</strong>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <CreditCardIcon style={{ color: "#6366f1", fontSize: "18px" }} />
                    <span style={{ fontWeight: 600, color: "#334155", fontSize: "13px" }}>Card Sales</span>
                  </div>
                  <strong style={{ color: "#0f172a", fontSize: "13px" }}>{formatAED(dashboardData?.salesCategories?.cardSales)}</strong>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Description style={{ color: "#f59e0b", fontSize: "18px" }} />
                    <span style={{ fontWeight: 600, color: "#334155", fontSize: "13px" }}>Cheques</span>
                  </div>
                  <strong style={{ color: "#0f172a", fontSize: "13px" }}>{formatAED(dashboardData?.salesCategories?.chequeSales)}</strong>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <PointOfSaleIcon style={{ color: "#ec4899", fontSize: "18px" }} />
                    <span style={{ fontWeight: 600, color: "#334155", fontSize: "13px" }}>Online Payments</span>
                  </div>
                  <strong style={{ color: "#0f172a", fontSize: "13px" }}>{formatAED(dashboardData?.salesCategories?.onlineSales)}</strong>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>

        <div className="stats-grid">
          <StatCard
            type="employee"
            title="Employees"
            value={dashboardData?.totalEmployees || 0}
            icon={People}
            additionalData={{
              active: dashboardData?.active_users || 0,
              inactive: dashboardData?.non_active_users || 0,
            }}
            onClick={(clicked) => {
              if (clicked === "total") {
                navigate("/employee/list", {
                  state: {
                    filters: [],
                  },
                });
              }
              if (clicked === "active") {
                navigate("/employee/list", {
                  state: {
                    filters: [{ id: "present_employee", value: 2 }],
                  },
                });
              }
              if (clicked === "inactive") {
                navigate("/employee/list", {
                  state: {
                    filters: [{ id: "present_employee", value: 3 }],
                  },
                });
              }
            }}
          />

          <StatCard
            title="Total Stores"
            value={dashboardData?.totalStores || 0}
            icon={StoreIcon}
            variant="secondary"
            navigateTo="/store/list"
          />

          <StatCard
            title="Total Vendors"
            value={dashboardData?.totalVendors || 0}
            icon={BusinessCenter}
            variant="tertiary"
            navigateTo="/vendor/list"
          />

          <StatCard
            title="Total Customers"
            value={dashboardData?.totalCustomers || 0}
            icon={Person}
            variant="quaternary"
            navigateTo="/customer/list"
          />

          <StatCard
            title="Total Departments"
            value={dashboardData?.totalDepartments || 0}
            icon={Business}
            variant="primary"
            navigateTo="/config/departments-master"
          />

          <StatCard
            title="Total Companies"
            value={dashboardData?.totalCompanies || 0}
            icon={Business}
            variant="secondary"
            navigateTo="/manage-companies/list"
          />
        </div>

        <style jsx>{`
          * {
            box-sizing: border-box;
          }

          .employee-card {
            background: linear-gradient(180deg, #ffffff, #f8f9fa);
            border-radius: 20px;
            padding: 20px;
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
            border: 1px solid #e9ecef;
            display: flex;
            flex-direction: column;
            gap: 20px;
            position: relative;
            overflow: hidden;
            transition: all 0.3s ease;
          }

          .employee-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          }

          .employee-card-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .employee-icon {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
          }

          .employee-card:hover .employee-icon {
            transform: scale(1.1);
            box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.12);
          }

          .employee-total {
            background: rgba(255, 255, 255, 0.7);
            padding: 10px 20px;
            border-radius: 12px;
            cursor: pointer;
            text-align: center;
            backdrop-filter: blur(10px);
            transition: all 0.3s ease;
          }

          .employee-total:hover {
            background: rgba(255, 255, 255, 0.9);
            transform: translateY(-2px);
          }

          .employee-total span {
            font-size: 14px;
            font-weight: 600;
            display: block;
            margin-bottom: 4px;
          }

          .employee-total h2 {
            margin: 0;
            font-size: 32px;
            font-weight: 800;
            line-height: 1;
          }

          .employee-breakdown {
            display: flex;
            justify-content: space-between;
            gap: 12px;
          }

          .employee-break-item {
            flex: 1;
            background: rgba(255, 255, 255, 0.7);
            padding: 16px 12px;
            border-radius: 12px;
            text-align: center;
            cursor: pointer;
            backdrop-filter: blur(10px);
            transition: all 0.3s ease;
          }

          .employee-break-item:hover {
            transform: translateY(-2px);
            box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
          }

          .employee-break-item span {
            font-size: 13px;
            font-weight: 600;
            color: #6c757d;
            display: block;
            margin-bottom: 6px;
          }

          .employee-break-item h3 {
            margin: 0;
            font-size: 26px;
            font-weight: 700;
            line-height: 1;
          }

          .dashboard-container {
            min-height: 100vh;
            background: #f8f9fa;
            padding: 24px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              Oxygen, Ubuntu, Cantarell, sans-serif;
          }
          .dashboard-header {
            background: white;
            border-radius: 16px;
            margin-top: 24px;
            padding: 24px;
            margin-bottom: 24px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            border: 1px solid #e9ecef;
          }
          .header-content {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }
          .date-display {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 24px;
            font-weight: 700;
            color: #972927;
          }
          .date-display svg {
            color: #972927;
          }
          .header-controls {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
          }
          .custom-select {
            position: relative;
            min-width: 200px;
            flex: 1;
          }
          .select-button {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 12px 16px;
            background: white;
            border: 1.5px solid #dee2e6;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 500;
            color: #495057;
            cursor: pointer;
            transition: all 0.2s ease;
          }
          .select-button:hover {
            border-color: #972927;
            background: #fef9f9;
          }
          .select-button svg:last-child {
            margin-left: auto;
            transition: transform 0.2s ease;
          }
          .select-button svg.rotate {
            transform: rotate(180deg);
          }
          .select-dropdown {
            position: absolute;
            top: calc(100% + 8px);
            left: 0;
            right: 0;
            background: white;
            border-radius: 10px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
            border: 1px solid #e9ecef;
            z-index: 100;
            max-height: 300px;
            overflow-y: auto;
            animation: slideDown 0.2s ease;
          }
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .select-option {
            padding: 12px 16px;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 14px;
            color: #495057;
          }
          .select-option:hover {
            background: #fef9f9;
            color: #972927;
          }
          .select-option:first-child {
            border-radius: 10px 10px 0 0;
          }
          .select-option:last-child {
            border-radius: 0 0 10px 10px;
          }
          .stats-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 20px;
          }
          .stat-card {
            position: relative;
            background: white;
            border-radius: 16px;
            padding: 28px;
            overflow: hidden;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            border: 1px solid #e9ecef;
          }
          .stat-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 24px rgba(151, 41, 39, 0.12);
            border-color: #972927;
          }
          .stat-content {
            position: relative;
            z-index: 2;
          }
          .stat-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 20px;
          }
          .stat-icon {
            width: 52px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 12px;
            transition: all 0.3s ease;
          }
          .stat-card:hover .stat-icon {
            transform: scale(1.1);
          }
          .stat-trend {
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 12px;
            font-weight: 600;
            padding: 6px 10px;
            border-radius: 20px;
          }
          .stat-title {
            font-size: 13px;
            font-weight: 600;
            margin: 0 0 12px 0;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .stat-value {
            font-size: 32px;
            font-weight: 800;
            line-height: 1;
          }
          .stat-decoration {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 4px;
            border-radius: 0 0 20px 20px;
          }

          /* Employee variant - Primary brand color */
          .employee-card.employee-variant .employee-icon {
            background: rgba(151, 41, 39, 0.15);
            color: #972927;
          }
          .employee-card.employee-variant .employee-total {
            color: #972927;
          }
          .employee-card.employee-variant .employee-total h2 {
            color: #972927;
          }
          .employee-card.employee-variant .employee-break-item {
            border: 1px solid rgba(151, 41, 39, 0.15);
          }
          .employee-card.employee-variant .employee-break-item:hover {
            background: rgba(151, 41, 39, 0.08);
          }
          .employee-card.employee-variant .employee-break-item h3 {
            color: #972927;
          }
          .employee-card.employee-variant .stat-decoration {
            background: linear-gradient(90deg, #972927, #b95250);
          }

          /* Sales Order variant - Green accent (complementary to red) */
          .employee-card.sales-order-variant .employee-icon {
            background: rgba(39, 151, 87, 0.15);
            color: #279757;
          }
          .employee-card.sales-order-variant .employee-total {
            color: #279757;
          }
          .employee-card.sales-order-variant .employee-total h2 {
            color: #279757;
          }
          .employee-card.sales-order-variant .employee-break-item {
            border: 1px solid rgba(39, 151, 87, 0.15);
          }
          .employee-card.sales-order-variant .employee-break-item:hover {
            background: rgba(39, 151, 87, 0.08);
          }
          .employee-card.sales-order-variant .employee-break-item h3 {
            color: #279757;
          }
          .employee-card.sales-order-variant .stat-decoration {
            background: linear-gradient(90deg, #279757, #34c76f);
          }

          /* Purchase Order variant - Blue accent (analogous to green) */
          .employee-card.purchase-order-variant .employee-icon {
            background: rgba(39, 103, 151, 0.15);
            color: #276797;
          }
          .employee-card.purchase-order-variant .employee-total {
            color: #276797;
          }
          .employee-card.purchase-order-variant .employee-total h2 {
            color: #276797;
          }
          .employee-card.purchase-order-variant .employee-break-item {
            border: 1px solid rgba(39, 103, 151, 0.15);
          }
          .employee-card.purchase-order-variant .employee-break-item:hover {
            background: rgba(39, 103, 151, 0.08);
          }
          .employee-card.purchase-order-variant .employee-break-item h3 {
            color: #276797;
          }
          .employee-card.purchase-order-variant .stat-decoration {
            background: linear-gradient(90deg, #276797, #3a8bc8);
          }

          /* Primary variant - Main brand color */
          .stat-card.primary .stat-icon {
            background: rgba(151, 41, 39, 0.1);
            color: #972927;
          }
          .stat-card.primary .stat-title {
            color: #6c757d;
          }
          .stat-card.primary .stat-value {
            color: #972927;
          }
          .stat-card.primary .stat-trend {
            background: rgba(151, 41, 39, 0.1);
            color: #972927;
          }
          .stat-card.primary .stat-decoration {
            background: #972927;
          }
          /* Secondary variant - Darker shade */
          .stat-card.secondary .stat-icon {
            background: rgba(123, 33, 31, 0.1);
            color: #7b211f;
          }
          .stat-card.secondary .stat-title {
            color: #6c757d;
          }
          .stat-card.secondary .stat-value {
            color: #7b211f;
          }
          .stat-card.secondary .stat-trend {
            background: rgba(123, 33, 31, 0.1);
            color: #7b211f;
          }
          .stat-card.secondary .stat-decoration {
            background: #7b211f;
          }
          /* Tertiary variant - Lighter shade */
          .stat-card.tertiary .stat-icon {
            background: rgba(185, 82, 80, 0.1);
            color: #b95250;
          }
          .stat-card.tertiary .stat-title {
            color: #6c757d;
          }
          .stat-card.tertiary .stat-value {
            color: #b95250;
          }
          .stat-card.tertiary .stat-trend {
            background: rgba(185, 82, 80, 0.1);
            color: #b95250;
          }
          .stat-card.tertiary .stat-decoration {
            background: #b95250;
          }
          /* Quaternary variant - Complementary neutral */
          .stat-card.quaternary .stat-icon {
            background: rgba(185, 82, 80, 0.1);
            color: #cd6f6e;
          }
          .stat-card.quaternary .stat-title {
            color: #6c757d;
          }
          .stat-card.quaternary .stat-value {
            color: #cd6f6e;
          }
          .stat-card.quaternary .stat-trend {
            background: rgba(185, 82, 80, 0.1);
            color: #cd6f6e;
          }
          .stat-card.quaternary .stat-decoration {
            background: #cd6f6e;
          }
          /* Responsive Design */
          @media (max-width: 640px) {
            .dashboard-container {
              padding: 16px;
            }
            .dashboard-header {
              margin-top: 54px;
              padding: 20px;
            }
            .date-display {
              font-size: 20px;
            }
            .header-controls {
              flex-direction: column;
            }
            .custom-select {
              min-width: 100%;
            }
            .stats-grid {
              grid-template-columns: 1fr;
              gap: 16px;
            }
            .stat-card {
              padding: 24px;
            }
            .stat-value {
              font-size: 36px;
            }
          }
          @media (min-width: 641px) and (max-width: 768px) {
            .stats-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }
          @media (min-width: 769px) and (max-width: 1024px) {
            .dashboard-header {
              margin-top: 24px;
            }
            .stats-grid {
              grid-template-columns: repeat(2, 1fr);
            }
            .header-content {
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            }
          }
          @media (min-width: 1025px) {
            .dashboard-header {
              margin-top: 24px;
            }
            .stats-grid {
              grid-template-columns: repeat(4, 1fr);
            }
            .header-content {
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            }
            .header-controls {
              flex-wrap: nowrap;
            }
          }
          @media (min-width: 1400px) {
            .dashboard-header {
              margin-top: 24px;
            }
            .dashboard-container {
              padding: 32px;
            }
          }
        `}</style>
      </div>
    </Layout>
  );
}
export default Dashboard;
